var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"capital-distribution-wrapper"},[_c('CapitalDistribution',{attrs:{"data":_vm.distributionData,"divisorUnit":_vm.divisorUnit,"market":_vm.market}}),_c('CapitalStatistical',{attrs:{"data":_vm.distributionData,"divisorUnit":_vm.divisorUnit}}),_c('CapitalHolding',{attrs:{"getUnit":_vm.getUnit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }